import type { SendMessageBrowserContext } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

/**
 * Builds the wire `browser` context. Do not send htmlBody or canvasText if the URL is
 * blocklisted, to ensure the site is truly not sent to the backend. A selection is text the
 * user deliberately highlighted, so it is still sent on blocklisted pages.
 */
export function buildBrowserRequestContext({
	browserContext,
	isBrowserContextBlocklisted,
	isBrowserSelectionContextGateEnabled,
}: {
	browserContext?: SendMessageBrowserContext;
	isBrowserContextBlocklisted: boolean;
	isBrowserSelectionContextGateEnabled: boolean;
}): Record<string, unknown> {
	if (!browserContext) {
		return {};
	}

	const browserSelection = isBrowserSelectionContextGateEnabled
		? browserContext.context?.selection
		: undefined;

	if (!isBrowserContextBlocklisted) {
		return {
			browser: {
				htmlBody: browserContext.context?.htmlBody,
				canvasText: browserContext.context?.canvasText,
				...(browserSelection ? { selection: browserSelection } : {}),
			},
		};
	}

	if (browserSelection) {
		return { browser: { selection: browserSelection } };
	}

	return {};
}
